/** InsCoder WANG.J 2026-06-22 B + Cherry cart bridge for GWP promotion engine **/
(function () {
  function getBundledSections() {
    const sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } })
    );
    return sections;
  }

  function updateCherryCartEmptyState() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    const sectionId = cartDrawer.getAttribute('data-section-id');
    const cartDrawerBody = document.querySelector(`#CartDrawerBody-${sectionId}`);
    const cartDrawerFooter = document.querySelector(`#CartDrawerFooter-${sectionId}`);
    const cartDrawerEmpty = document.querySelector(`#CartDrawerEmpty-${sectionId}`);

    if (!cartDrawerBody || !cartDrawerFooter || !cartDrawerEmpty) return;

    const hasProducts =
      window.cartItemsData &&
      window.cartItemsData.productData &&
      window.cartItemsData.productData.length > 0;

    if (hasProducts) {
      cartDrawerBody.classList.remove('hidden');
      cartDrawerFooter.classList.remove('hidden');
      cartDrawerEmpty.classList.add('hidden');
    } else {
      cartDrawerBody.classList.add('hidden');
      cartDrawerFooter.classList.add('hidden');
      cartDrawerEmpty.classList.remove('hidden');
    }
  }

  window.refreshGwpProgressBars = function () {
    document.querySelector('cart-progress-bar')?.renderCartProgressBar();
    document.querySelectorAll('cart-page-progress-bar').forEach((el) => {
      if (typeof el.renderCartPageProgressBar === 'function') {
        el.renderCartPageProgressBar();
      }
    });
  };

  window.gwpPromotionsActive = function () {
    return Boolean(
      window.promotionSettings &&
        window.promotionSettings.gwp &&
        window.promotionSettings.gwp.length
    );
  };

  if (!window.refreshCart) {
    window.refreshCart = function (cartShow = false) {
      const sections = getBundledSections();

      return fetch(`${window.FoxTheme.routes.cart_update_url}`, {
        ...window.FoxTheme.utils.fetchConfig(),
        body: JSON.stringify({
          sections: sections,
          sections_url: window.location.pathname,
        }),
      })
        .then((response) => response.json())
        .then((cartJson) => {
          if (typeof window.buildGwpCartItemsData === 'function') {
            window.buildGwpCartItemsData(cartJson);
          }

          const hasSectionHtml =
            sections.length > 0 &&
            cartJson.sections &&
            sections.every((id) => Boolean(cartJson.sections[id]));

          window.FoxTheme.pubsub.publish(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });

          if (!hasSectionHtml) {
            document.dispatchEvent(
              new CustomEvent('cart:refresh', {
                detail: { open: cartShow },
              })
            );
          }

          updateCherryCartEmptyState();
          window.refreshGwpProgressBars();

          if (cartShow) {
            document.querySelector('cart-drawer')?.show();
          }

          return cartJson;
        });
    };
  }

  window.KROWN = window.KROWN || {};
  window.KROWN.settings = window.KROWN.settings || {};
  window.KROWN.settings.routes = window.FoxTheme.routes;
  if (window.FoxTheme.promotionLocales) {
    window.KROWN.settings.locales = window.FoxTheme.promotionLocales;
  }

  function initPromotionCodeHandlers() {
    window.restoreGwpPromoCodeFromStorage?.();
  }

  if (!window.__gwpPromoCodeClickBound) {
    window.__gwpPromoCodeClickBound = true;

    document.addEventListener('click', (event) => {
      const applyButton = event.target.closest('#discount_apply');
      if (applyButton) {
        event.preventDefault();
        window.addCodeStack?.(event);
        return;
      }

      const removeButton = event.target.closest('.discount-code-input-close');
      if (removeButton) {
        event.preventDefault();
        window.removeCodeStack?.();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initPromotionCodeHandlers);
  document.addEventListener('cart:updated', () => {
    initPromotionCodeHandlers();
    window.syncGwpGiftQuantityVisibility?.(document);
  });
  document.addEventListener('cart:refresh', () => {
    requestAnimationFrame(initPromotionCodeHandlers);
  });
})();
/** InsCoder WANG.J 2026-06-22 E + Cherry cart bridge for GWP promotion engine **/
